import { render, staticRenderFns } from "./base_de_donnees.vue?vue&type=template&id=53157563&scoped=true"
import script from "./base_de_donnees.vue?vue&type=script&lang=js"
export * from "./base_de_donnees.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53157563",
  null
  
)

export default component.exports